import api from "../api/axios";

export const createBoleta = async (orderId) => {
  const response = await api.post(`/receipts/order/${orderId}/boleta`);
  return response.data;
};

export const createNotaDeCredito = async (boletaDocumentId) => {
  const response = await api.post(
    `/receipts/order-documents/${boletaDocumentId}/nota-credito`,
  );
  return response.data;
};

export const fetchOrderDocuments = async (orderId) => {
  const response = await api.get(`/receipts/order/${orderId}/documents`);
  return response.data;
};

export const downloadDocument = async (documentId, filename) => {
  try {
    const response = await api.get(
      `/receipts/order-documents/${documentId}/download`,
      { responseType: "blob" },
    );
    const url = window.URL.createObjectURL(response.data);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${filename || documentId}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    // Error responses are also blobs when responseType is 'blob'
    if (error.response?.data instanceof Blob) {
      const text = await error.response.data.text();
      try {
        const json = JSON.parse(text);
        throw new Error(json.message || "Error al descargar el documento.");
      } catch {
        throw new Error("Error al descargar el documento.");
      }
    }
    throw error;
  }
};
